import Reac, { useEffect, useState } from 'react';
import { Form, Col, Row, Card, Tag, Spin } from 'antd';
import { FormInstance } from 'antd/lib/form';
import GetLabel from 'DisplayFramework/components/GetLabel';
import IntramarqueCard from './IntraMarqueCard';
import StatCard from 'components/theme_components/StatCard';
import { getSiloBrandList } from 'services/thirdParty';
import { useQuery } from 'react-query';
import { getProductList } from 'services/parametersService';

export type IntramarqueListProps = {
  form: FormInstance;
  tpid: number;
  color: string;
  itemsCompanyHierarchyTree: any[];
  tptype?: string;
  keyProps: string;
};

const IntramarqueList = (props: IntramarqueListProps) => {
  const [visible, setVisible] = useState(false);
  const { form, tpid, color, itemsCompanyHierarchyTree, tptype, keyProps } = props;
  const [siloPrCode, setSiloPrCode] = useState("VN");

  const { data: products } = useQuery('getProductList', () =>
    getProductList().then((res) => {
      return res.list || [];
    }),
    { refetchOnWindowFocus: false }

  );

  const { data: siloList, isLoading, refetch } = useQuery(
    ['getSiloBrandListSILOINTRA', tpid, siloPrCode, keyProps],
    () => getSiloBrandList({
      silotpid: tpid,
      siloprcode: siloPrCode,
      silotype: "SILOINTRA"
    }).then((res) => {
      let exclusionsAuthList: any[] = [];
      if (res.list.length > 0) {
        res.list.map((silo: any) => {
          let exclusionsAuthList = silo.tpAuthorizationResponses.filter((auth: any) => auth.flagexcludpermeabilitypm);
          silo.exclusionsAuthList = exclusionsAuthList;
        })
      }
      return res.list || []
    }),
    { enabled: tpid != null }
  );


  return (
    <Form form={form}>
      <Row gutter={[16, 16]} justify="center">
        <Col span={24}>
          <StatCard
            title=""
            value={
              'Un tiers moral possédant plusieurs tiers physiques sous une même NSC peut cumuler les lignes de crédits de ses différents tiers physiques par produit.\n \n  ' +
              "Le but de cette page est de permettre d'activer ou désactiver un silo et d’exclure d'un tiers physique du silo auquel il appartient. Ainsi,il sera exclu des options de perméabilité et le contrôle de crédit se fera sur ses propres limites et non plus sur celle du Groupe auquel il appartient."
            }
            className="mb-5 blue staticNotf"
            variant="secondary"
            valueStyle={{ whiteSpace: 'pre-line' }}
          />
        </Col>
        <Col span={24}>

          {products?.map((product, index) => {
            return (
              <Tag
                key={index}
                color={color}
                className={`tag-status font-size-13 ml-2 p-2 tag-status-${product.prcode == siloPrCode ? 'primary' : 'secondary'}`}
                bordered={false}
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  setSiloPrCode(product.prcode)
                }}
              >
                {product.prcode}
              </Tag>
            )
          })}
        </Col>
        <Col span={24}>
          <Card className="transparent">
            <Row gutter={5} justify="start">
              <Col span={3}>
                <GetLabel
                  className="gray-color mb-0 font-size-13 bold "
                  label="silos"
                />
              </Col>
              <Col span={10}>
                <GetLabel
                  className="gray-color mb-0 font-size-13 bold "
                  label="exclusions"
                />
              </Col>

              <Col span={3}>
                <GetLabel
                  className="gray-color mb-0 font-size-13 bold "
                  label="availableamount"
                />
              </Col>

              <Col span={3}>
                <GetLabel
                  className="gray-color mb-0 font-size-13 bold "
                  label="availableamountmpea"
                />
              </Col>
              <Col span={2} />

              <Col span={3}>
                {' '}
                <span className="floatRight">
                  {' '}
                  <GetLabel
                    className="gray-color text-right mb-0 font-size-13 bold "
                    label="activated"
                  />
                </span>{' '}
                <span className="floatRight mr-5">
                  <GetLabel
                    className=" gray-color text-right mb-0 font-size-13 bold "
                    label="update"
                  />
                </span>
              </Col>
            </Row>
          </Card>
        </Col>
        <Col span={24} className="">
          <Spin spinning={isLoading}>
            {siloList?.map((silo) => (
              <IntramarqueCard
                key={silo.siloid}
                silo={silo}
                action="edit"
                tpid={tpid}
                hideDeletebtn={false}
                refetch={() => {
                  refetch()
                }}
                tptype={tptype}
              />
            ))}
          </Spin>

        </Col>
      </Row>
    </Form>
  );
};

export default IntramarqueList;
